import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import ProductHeader from "../ProductDetails/ProductHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

import Address from "./Address";
import OrderDetails from "./OrderDetails";
import PaymentInfo from "./PaymentInfo";
import "./index.css";
import moment from "moment";
import io from "socket.io-client";
import Hmm from "./assets/hmm.png";
import NavigationOutlinedIcon from "@material-ui/icons/NavigationOutlined";
import PersonIcon from "@material-ui/icons/Person";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import CallIcon from "@material-ui/icons/Call";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GpsFixedIcon from "@material-ui/icons/GpsFixed";
// Statuses
import { ReactComponent as New } from "./assets/success.svg";
import { ReactComponent as Received } from "./assets/received.svg";
import { ReactComponent as Preparing } from "./assets/preparing.svg";
import { ReactComponent as Delivering } from "./assets/delivering.svg";
import { ReactComponent as Complete } from "./assets/complete.svg";
import { ReactComponent as Cancelled } from "./assets/cancelled.svg";
import { ReactComponent as Ready } from "./assets/pickup.svg";
import { ReactComponent as ReadyQRTable } from "./assets/Dine.svg";
import { ReactComponent as Refunded } from "./assets/refund.svg";
import Feedback from "./Feedback";
import Gifts from "./Gifts";
import BenefitTransfer from "./BenefitTransfer";
import LoyaltyPoints from "./LoyaltyPoints";
import DigitalDownloadNotification from "./DigitalDownloadNotification";
import Payment from "./Payment";
import ActionButton from "../ActionButton";
import QRCode from "qrcode.react";
import DriverTrackingMap from "./DriverTrackingMap";
import Invite from "./Invite";

function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}

export class index extends Component {
  state = {
    order: null,
    loading: true,
    socket: null,
    showPayment: false,
  };

  resetTableNumber = () => {
    if (
      (this.state.order?.payment_complete ||
        ["Cancelled", "Refunded"].includes(this.state.order?.status)) &&
      this.props.parkingNumber &&
      this.state.order?.tracking_id ===
        (localStorage.getItem("dine_in_order_id") || this.props.dineInOrderID)
    ) {
      this.props.modifyAddress({
        parkingNumber: "",
        token: null,
        dineInOrderID: null,
      });
      localStorage.removeItem("dine_in_order_id");
    }
  };
  componentDidUpdate = () => {
    if (this.props.settings.enable_table_qr) {
      this.resetTableNumber();
    }
  };
  componentDidMount = async () => {
    if (!this.props.store.settings.enable_tracking) return;
    window.scrollTo(0, 0);
    if (!this.props.match.params.tracking_id) return;
    await this.fetchDetails();
    this.setState({ loading: false });
    if (this.props.settings.enable_table_qr) {
      this.resetTableNumber();
    }
  };

  componentWillUnmount = () => {
    if (this.state.socket) this.state.socket.disconnect();
  };

  fetchDetails = async () => {
    let res = null;
    const { country_code } = this.props;
    res = await instance.post(
      `/track_order_new/${this.props.match.params.tracking_id.trim()}/`,
      {
        country_code,
      },
    );
    if (!res.data.success) {
      return;
    }
    this.setState({ order: res.data.data });
    if (res.data.success && res.data.data && !this.state.socket) {
      const socket = io(
        `https://socket.tapcom.com/?trackingID=${this.props.match.params.tracking_id.trim()}`,
      );
      this.setState({ socket: socket });

      socket.on("orderStatusUpdated", (data) => {
        this.fetchDetails();
      });
    }
  };

  renderStatusImage = () => {
    const { order } = this.state;
    const style = { width: 80, height: 80 };
    if (order.status.toLowerCase().includes("new")) {
      return <New style={style} />;
    } else if (
      order.status.toLowerCase().includes("preparing") ||
      order.status == "Open"
    ) {
      return <Preparing style={style} />;
    } else if (order.status.toLowerCase().includes("received")) {
      return <Received style={style} />;
    } else if (order.status.toLowerCase().includes("delivery")) {
      if (order.is_delivery) return <Delivering style={style} />;
      else
        return this.props.settings.enable_table_qr ? (
          <ReadyQRTable
            style={{
              width: 100,
              height: 100,
            }}
          />
        ) : (
          <Ready style={style} />
        );
    } else if (order.status.toLowerCase().includes("complete")) {
      return <Complete style={style} />;
    } else if (order.status.toLowerCase().includes("cancel")) {
      return <Cancelled style={style} />;
    } else if (order.status.toLowerCase().includes("refunded")) {
      return <Refunded style={style} />;
    }
  };

  renderOrderStatus = (status, isDelivery) => {
    const { language, settings } = this.props;
    if (language == "english") {
      if (status.toLowerCase() === "new pos") {
        return "New";
      }
      if (status.toLowerCase().includes("delivery")) {
        return isDelivery
          ? "Out for Delivery"
          : settings.enable_table_qr
            ? "Ready"
            : "Ready to collect";
      } else if (status.toLowerCase().includes("received")) {
        return "Accepted";
      } else if (status == "Open") {
        return "Preparing";
      } else return status;
    }

    if (status.toLowerCase().includes("new")) {
      return "جديد";
    } else if (
      status.toLowerCase().includes("preparing") ||
      status === "Open"
    ) {
      return "يتم تحضيره";
    } else if (status.toLowerCase().includes("received")) {
      return "تم القبول";
    } else if (status.toLowerCase().includes("delivery")) {
      if (isDelivery) return "يتم توصيله";
      else return settings.enable_table_qr ? "جاهز" : "جاهز للاستلام";
    } else if (status.toLowerCase().includes("complete")) {
      return "مكتمل";
    } else if (status.toLowerCase().includes("cancel")) {
      return "ملغي";
    } else if (status.toLowerCase().includes("refunded")) {
      return "مسترجع";
    } else if (status.toLowerCase().includes("driver pending")) {
      return "بإنتظار السائق";
    }
  };

  renderExpectedStartEnd = (dateTime) => {
    if (!dateTime || dateTime.includes("None")) return "";
    let temp = dateTime.split(" ");
    let start = temp[1];
    let end = temp[temp.length - 1];

    return `${moment(start, "HH:mm:ss").format("h:mm A")} - ${moment(
      end,
      "HH:mm:ss",
    ).format("h:mm A")}`;
  };

  render() {
    const { language, themeColor, settings } = this.props;
    const { loading, order, showPayment } = this.state;
    const isDigitProductInOrder = order
      ? order.items.some((item) => item.type_of_product === "digital")
      : false;
    if (!this.props.store.settings.enable_tracking)
      this.props.history.replace("/");
    if (!this.props.match.params.tracking_id) this.props.history.replace("/");

    if (loading)
      return (
        <div style={{ backgroundColor: "white", height: "100vh" }}>
          <ProductHeader
            title={language == "english" ? "Order Tracking" : "تتبع الطلب"}
            onBack={() =>
              this.props.history.location.state &&
              this.props.history.location.state.fromPastOrders
                ? this.props.history.goBack()
                : this.props.history.replace("/")
            }
          />
          <CircularProgress color="primary" style={{ marginTop: 80 }} />
        </div>
      );
    if (!order) {
      return (
        <div style={{ minHeight: "calc(100vh - 55px)" }}>
          <ProductHeader
            title={language == "english" ? "Order Tracking" : "تتبع الطلب"}
            onBack={() =>
              this.props.history.location.state &&
              this.props.history.location.state.fromPastOrders
                ? this.props.history.goBack()
                : this.props.history.replace("/")
            }
          />
          <div style={{ marginTop: 100 }}>
            <img src={Hmm} style={{ width: 180, height: 200 }} />
            <p className="mt-3">
              {language == "english"
                ? "Sorry.. Can't find the order you're looking for"
                : "عذرا.. لم نتمكن من ايجاد الطلب"}
            </p>
          </div>
        </div>
      );
    }

    const showDriverSection =
      settings.enable_driver &&
      (settings.show_driver_info_on_dispatch ||
        order.status === "Out for Delivery");
    const orderShippingStatus = {
      "go to branch":
        language === "english"
          ? "Driver accepted the order."
          : "تم قبول الطلب.",

      "pick up":
        language === "english"
          ? "Driver picking up order."
          : "السائق يستلم الطلب.",

      navigate:
        language === "english"
          ? "Driver is heading your way."
          : "السائق في طريقه إليك.",

      deliver:
        language === "english"
          ? "Delivering your order."
          : "يتم توصيل الطلب الآن.",
    };
    return (
      <div
        style={{
          backgroundColor: "#f9fafa",
          minHeight: window.outerHeight,
          direction: language == "english" ? "ltr" : "rtl",
        }}
      >
        <ProductHeader
          title={language == "english" ? "Order Tracking" : "تتبع الطلب"}
          onBack={() =>
            this.props.history.location.state &&
            this.props.history.location.state.fromPastOrders
              ? this.props.history.goBack()
              : this.props.history.replace("/")
          }
        />
        <div className="free-space-50-white"></div>

        <div
          style={{
            height:
              order.expected_delivery_date_time &&
              !order.expected_delivery_date_time.includes("None") &&
              !settings.enable_car_qr &&
              !settings.enable_table_qr
                ? 164
                : 115,
            backgroundColor: themeColor,
            width: "100%",
            marginBottom:
              order.expected_delivery_date_time &&
              !order.expected_delivery_date_time.includes("None") &&
              !settings.enable_car_qr &&
              !settings.enable_table_qr
                ? 100
                : 85,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              position: "relative",
              top: 45,
              height:
                order.expected_delivery_date_time &&
                !order.expected_delivery_date_time.includes("None") &&
                !settings.enable_car_qr &&
                !settings.enable_table_qr
                  ? 195 - (order.is_international ? 22 : 0)
                  : 125 +
                    (settings.enable_additional_fee &&
                    showPayment &&
                    settings.enable_table_qr
                      ? 50
                      : 0),
              borderRadius: 5,
              marginLeft: "auto",
              marginRight: "auto",
              width: "87%",
              boxShadow: "black 0px 1px 14px -9px",
              zIndex: 1,
            }}
          >
            <div
              className="center-y"
              style={{
                position: "absolute",
                right: language == "english" && 20,
                left: language == "arabic" && 20,
                zIndex: 10,
              }}
            >
              {this.renderStatusImage()}
              {order.is_delivery &&
              order.tracking_link &&
              order.status.toLowerCase().includes("deliver") ? (
                <a
                  href={order.tracking_link}
                  target="_blank"
                  style={{ color: themeColor }}
                >
                  <p className="m-0 mt-2">
                    <NavigationOutlinedIcon />{" "}
                    {language == "english" ? "Track order" : "تتبع الطلب"}
                  </p>
                </a>
              ) : null}
            </div>
            <div
              className={language == "english" ? "text-left" : "text-right"}
              style={{
                top: 15,
                left: language == "english" && 15,
                right: language == "arabic" && 15,
                position: "relative",
              }}
            >
              <p className="m-0" style={{ color: "#999" }}>
                {language == "english" ? "Order tracking ID" : "رقم التتبع"}
              </p>
              <p className="bold m-0">
                {order.enable_code || order.tracking_id}
              </p>
              <p className="mb-0" style={{ color: "#999", marginTop: 5 }}>
                {language == "english" ? "Your order status is" : "حالة الطلب"}
              </p>
              <h2
                className="bold m-0"
                style={{
                  fontFamily: language == "english" ? "Quicksand" : "Cairo",
                  fontSize:
                    order.status.toLowerCase().includes("deliver") && 20,
                }}
              >
                {this.renderOrderStatus(order.status, order.is_delivery)}
              </h2>
              {settings.enable_driver &&
                order?.driver_id &&
                showDriverSection && (
                  <p className="bold mb-0" style={{ color: "black" }}>
                    {orderShippingStatus[
                      order?.shipping_status?.toLowerCase()
                    ] || ""}
                  </p>
                )}

              {order.expected_delivery_date_time &&
                !order.expected_delivery_date_time.includes("None") &&
                !settings.enable_car_qr &&
                !settings.enable_table_qr && (
                  <>
                    <p className="mb-0" style={{ color: "#999", marginTop: 5 }}>
                      {language == "english"
                        ? `Expected date ${
                            !order.is_international ? "and time" : ""
                          }`
                        : `التاريخ ${
                            !order.is_international ? "والوقت" : ""
                          } المتوقع`}
                    </p>
                    {settings.show_on_demand_text_on_invoice &&
                    order.on_demand_text ? (
                      language == "english" ? (
                        <p className="bold m-0">
                          {settings.enable_on_demand_custom_string &&
                          !order.is_pickup
                            ? settings.on_demand_custom_string
                              ? settings.on_demand_custom_string
                              : settings.on_demand_custom_string_ar
                            : settings.enable_on_demand_custom_string_pickup &&
                                order.is_pickup
                              ? settings.on_demand_pickup_custom_string
                                ? settings.on_demand_pickup_custom_string
                                : settings.on_demand_pickup_custom_string_ar
                              : order.on_demand_text}
                        </p>
                      ) : (
                        <p className="bold m-0">
                          {settings.enable_on_demand_custom_string &&
                          !order.is_pickup
                            ? settings.on_demand_custom_string_ar
                              ? settings.on_demand_custom_string_ar
                              : settings.on_demand_custom_string
                            : settings.enable_on_demand_custom_string_pickup &&
                                order.is_pickup
                              ? settings.on_demand_pickup_custom_string_ar
                                ? settings.on_demand_pickup_custom_string_ar
                                : settings.on_demand_pickup_custom_string
                              : order.on_demand_text}
                        </p>
                      )
                    ) : (
                      <>
                        <p className="bold m-0">
                          {moment(
                            order.expected_delivery_date_time,
                            "YYYY-MM-DD HH:mm:ss - HH:mm:ss",
                          ).format("YYYY-MM-DD")}
                        </p>
                        {!order.is_international && (
                          <p className="bold m-0" style={{ direction: "ltr" }}>
                            {this.renderExpectedStartEnd(
                              order.expected_delivery_date_time,
                            )}
                          </p>
                        )}
                      </>
                    )}
                  </>
                )}

              {settings.enable_table_qr &&
                !!order.total &&
                showPayment &&
                settings.enable_additional_fee && (
                  <div>
                    <p className="mb-0" style={{ color: "#999", marginTop: 5 }}>
                      {language == "english" ? "Total" : "الاجمالي"}
                    </p>
                    <p className="bold m-0">
                      {(order.total - order.additional_fee).toFixed(
                        settings.base_currency_decimals,
                      )}{" "}
                      {language == "english"
                        ? settings.base_currency
                        : settings.base_currency_local}
                    </p>
                  </div>
                )}
            </div>
          </div>
          <div
            className="custom-shape-divider-bottom-1600838730"
            style={{
              top:
                order.expected_delivery_date_time &&
                !order.expected_delivery_date_time.includes("None") &&
                !settings.enable_car_qr &&
                !settings.enable_table_qr
                  ? 194
                  : 145,
            }}
          >
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                opacity=".25"
                className="shape-fill"
              ></path>
              <path
                d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                opacity=".5"
                className="shape-fill"
              ></path>
              <path
                d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </div>
        {settings.enable_teasers_staff && settings.enable_teasers && (
          <Invite
            order={order}
            history={this.props.history}
            updateOrder={(o) => this.setState({ order: o })}
          />
        )}

        {showPayment ? (
          <Payment order={order} />
        ) : (
          <>
            {order.payment_method === "benefit-transfer" && (
              <BenefitTransfer
                order={order}
                language={language}
                themeColor={themeColor}
                whatsappOption={
                  this.props.settings.benefit_transfer_whatsapp_option
                }
              />
            )}

            {isDigitProductInOrder && (
              <DigitalDownloadNotification order={order} />
            )}
            {!this.props.settings.enable_table_qr &&
              settings.show_delivery_provider_on_invoices &&
              order.order_tracking_reference_id && (
                <div
                  style={{
                    backgroundColor: "white",
                    minHeight: 65,
                    padding: "15px 5px",
                    alignItems: "center",
                  }}
                  className="border w-100 row m-0 my-4"
                >
                  <div className="col-2" style={{ position: "relative" }}>
                    <GpsFixedIcon
                      className="center-x-y"
                      style={{ fontSize: 32, color: "#999" }}
                    />
                  </div>
                  <div
                    className={"col-10 py-3 ".concat(
                      language === "english" ? "text-left" : "text-right",
                    )}
                  >
                    <p className="mb-1 bold">
                      <div>
                        {language === "english"
                          ? "Order Tracking Reference"
                          : "الرقم المرجعي"}
                      </div>
                      <div style={{ fontSize: "0.85em", color: "#666" }}>
                        {order.order_tracking_reference_id}
                      </div>
                    </p>
                  </div>
                </div>
              )}

            {!this.props.settings.enable_table_qr && (
              <div
                style={{
                  backgroundColor: "white",
                  minHeight: 65,
                  padding: "15px 5px",
                  alignItems: "center",
                }}
                className="border w-100 row m-0 my-4"
              >
                <div className="col-2" style={{ position: "relative" }}>
                  <PersonIcon
                    className="center-x-y"
                    style={{ fontSize: 32, color: "#999" }}
                  />
                </div>
                <div
                  className={"col-10 py-3 ".concat(
                    language === "english" ? "text-left" : "text-right",
                  )}
                >
                  <p className="mb-1 bold">
                    <div>{order.customer_name}</div>
                    <div style={{ fontSize: "0.85em", color: "#666" }}>
                      {order.phone}
                    </div>
                  </p>
                </div>
              </div>
            )}
            {settings.enable_driver &&
              order?.driver_id !== "" &&
              order?.driver_id !== undefined &&
              showDriverSection && (
                <div
                  style={{
                    backgroundColor: "white",
                    minHeight: 65,
                    padding: "15px 5px",
                    alignItems: "center",
                  }}
                  className="border w-100 row m-0 my-4"
                >
                  {settings.show_driver_info_on_dispatch &&
                    this.state.order.driver_name &&
                    this.state.order.driver_phone && (
                      <div className="w-100 row m-0 my-4">
                        <div className="col-2" style={{ position: "relative" }}>
                          <DriveEtaIcon
                            className="center-x-y"
                            style={{ fontSize: 32, color: "#999" }}
                          />
                        </div>
                        <div
                          className={"col-10 py-3 ".concat(
                            language === "english" ? "text-left" : "text-right",
                          )}
                        >
                          <p className="mb-1 bold" style={{ display: "flex" }}>
                            <div style={{ minWidth: "fit-content" }}>
                              <div style={{ marginBottom: "5px" }}>
                                {language == "arabic"
                                  ? "معلومات السائق:"
                                  : "Driver's details:"}
                              </div>
                              <div style={{ color: "#666" }}>
                                {order.driver_name}
                              </div>
                              <div
                                style={{
                                  fontSize: "0.85em",
                                  color: "#666",
                                  direction: "ltr",
                                }}
                              >
                                {order.driver_phone}
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                alignContent: "center",
                                justifyItems: "end",
                              }}
                            >
                              <div
                                style={{
                                  alignContent: "center",
                                }}
                              >
                                <Button
                                  style={{
                                    color: "#FFF",
                                    backgroundColor: themeColor,
                                    border: "1px solid #DEDEDE",
                                    borderRadius: 5,
                                    textTransform: "none",
                                    boxShadow: "none",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    width: 40,
                                    height: 40,
                                    marginInline: 5,
                                  }}
                                  onClick={() =>
                                    window.open(
                                      `tel:${order.driver_phone}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <CallIcon style={{ width: 20, height: 20 }} />
                                </Button>
                                <Button
                                  style={{
                                    color: "#FFF",
                                    backgroundColor: "#27AC01",
                                    border: "1px solid #DEDEDE",
                                    borderRadius: 5,
                                    textTransform: "none",
                                    boxShadow: "none",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    width: 40,
                                    height: 40,
                                    marginInline: 5,
                                  }}
                                  onClick={() =>
                                    window.open(
                                      `https://wa.me/${order.driver_phone.replace(
                                        "+",
                                        "",
                                      )}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <WhatsAppIcon
                                    style={{ width: 20, height: 20 }}
                                  />
                                </Button>
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    )}

                  {order.status === "Out for Delivery" &&
                    order?.shipping_status?.toLowerCase() === "deliver" &&
                    this.props.settings.enable_driver_live_tracking && (
                      <DriverTrackingMap
                        orderTracking={order?.tracking_id}
                        driverId={order?.driver_id}
                        branchLocation={order?.branch_destination}
                        status={order.status}
                        destinationLocation={order?.customer_destination}
                      />
                    )}
                </div>
              )}
            {this.props.settings.enable_feedback && (
              <Feedback order={order} history={this.props.history} />
            )}

            {(order.is_delivery &&
              order.address &&
              (order.address.area || order.address.zone)) ||
            (!order.is_delivery &&
              order.pickup_from &&
              (order.has_charged_items || order.has_delivered_items)) ? (
              <Address
                order={order}
                updateOrder={(o) => this.setState({ order: o })}
                history={this.props.history}
              />
            ) : null}

            {order.is_gift && <Gifts order={order} />}
            {order.loyalty_points_added > 0 && (
              <LoyaltyPoints points={order.loyalty_points_added} />
            )}
            <OrderDetails order={order} />

            {settings.show_invoice_qr && (
              <div
                style={{
                  backgroundColor: "white",
                  minHeight: 65,
                  padding: "15px 5px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                className="border mt-4"
              >
                <div className="my-auto bold" style={{ marginBottom: "15px" }}>
                  {/* {t("QR Code")} */}
                </div>
                <div>
                  <QRCode
                    value={`https://${this.props.domain}/track/order/${order.tracking_id}`}
                    size={170}
                    id={"QR".concat(order.tracking_id)}
                  />
                </div>
              </div>
            )}

            {!window.location.hostname?.includes(
              "generalassembly.ordable.com",
            ) &&
              (!settings.enable_table_qr || order.payment_complete) && (
                <PaymentInfo order={order} />
              )}

            {settings.enable_table_qr &&
              !order.payment_complete &&
              !["Cancelled", "Refunded"].includes(order?.status) && (
                <ActionButton
                  action={language == "english" ? "Pay" : "الدفع"}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    this.setState({ showPayment: true });
                  }}
                  color="#0099cc"
                />
              )}
          </>
        )}

        <div style={{ height: 100 }}></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    currency: state.currency,
    parkingNumber: state.customers.address?.parkingNumber,
    dineInOrderID: state.customers.address?.dineInOrderID,
    domain: state.store.store.domain,
    country_code: state.store.store.country_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
